import { Col, Row } from "antd";
import styled from "styled-components";
import { dateCommon } from "../../helpers/common";

const PrintPage = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page {
      size:portrait;
      background-color: white;
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 1cm;
      margin-right: 1cm;
    }
    div {
      font-family:'Times New Roman',Times,serif !important;
    }
    label {
      font-family:'Times New Roman',Times,serif !important;
    }
    .signature {
      text-align: center;
      margin-top: 25px;
    }
    .sign-block {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: 160px;
      justify-content: flex-start;
    }
    .title {
      font-weight: bold;
      text-transform: uppercase;
    }
    .signed {
      margin-top: 6px;
    }
    .time {
      font-size: 13px;
      margin-top: 4px;
    }
    .name {
      margin-top: 70px;
      font-weight: bold;
    }
    .sign-block .signed ~ .name,
    .sign-block .time ~ .name {
      margin-top: 50px;
    }
  }
`;

const InDangKyDaoTaoNam = ({ data }: { data: any }) => {
    const now = new Date();
    return (
        <section>
            <div style={{ backgroundColor: 'white' }} className="document">
                <PrintPage >
                    <div className="text-center pt-2">
                        <Row gutter={8}>
                            <Col span={12} >
                                <label>QUỸ ĐẦU TƯ PHÁT TRIỂN THÀNH PHỐ ĐÀ NẴNG <br /> <span>{data?.nguoiTrinh?.tenDonVi?.toUpperCase() || "VĂN PHÒNG"}</span>
                                    <hr style={{ borderTop: "1px solid", width: "20%", marginLeft: '36mm', marginTop: "1px", marginBottom: "1px" }} /> <br />
                                </label> 
                            </Col>
                            <Col span={12}  >
                                <label>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM <br /> <span>Độc lập - Tự do  - Hạnh phúc</span><hr style={{ borderTop: "1px solid", width: "50%", marginLeft: '18mm', marginTop: "1px", marginBottom: "2px" }} /> </label>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col span={12}>
                            </Col>
                            <Col span={12}>
                                {(() => {
                                    const thoiGian = data?.nguoiTrinh?.thoiGian
                                        ? new Date(data.nguoiTrinh.thoiGian)
                                        : now;
                                    return (
                                        <div className="font-italic">Đà Nẵng, ngày {("0" + thoiGian.getDate()).slice(-2)}  tháng {("0" + (thoiGian.getMonth() + 1)).slice(-2)}  năm {thoiGian.getFullYear()}</div>

                                    );
                                })()}
                            </Col>
                        </Row>
                    </div>
                    <div style={{ marginLeft: "30px" }} dangerouslySetInnerHTML={{ __html: data?.noiDung || '' }} />
                    <div className="signature">
                        {data?.idPhoCVP > 0 && data?.idChanhVP > 0 ? <Row gutter={8}>
                            <Col span={8} className="sign-block">
                                <div className="title">CHÁNH VĂN PHÒNG</div>
                                {data?.lanhDaoPhong != null ? (
                                    <>
                                        <div className="signed">Đã ký</div>
                                        <div className="time">
                                            {dateCommon.formatDate(data?.lanhDaoPhong.thoiGian, "HH:mm dd/MM/yyyy")}
                                        </div>
                                        <div className="name">{data?.lanhDaoPhong.tenNguoiKy}</div>
                                    </>
                                ) : (
                                    <div className="name">{data?.tenChanhVP || ''}</div>
                                )}
                            </Col>
                            <Col span={8} className="sign-block">
                                <div className="title">PHÓ CHÁNH VĂN PHÒNG</div>
                                {data?.phoCVP != null ? (
                                    <>
                                        <div className="signed">Đã ký</div>
                                        <div className="time">
                                            {dateCommon.formatDate(data?.phoCVP.thoiGian, "HH:mm dd/MM/yyyy")}
                                        </div>
                                        <div className="name">{data?.phoCVP.tenNguoiKy}</div>
                                    </>
                                ) : (
                                    <div className="name">{data?.tenPhoCVP || ''}</div>
                                )}
                            </Col>
                            <Col span={8} className="sign-block">
                                <div className="title">NGƯỜI TRÌNH</div>
                                {data?.nguoiTrinh != null ? (
                                    <>
                                        <div className="signed">Đã ký</div>
                                        <div className="time">
                                            {dateCommon.formatDate(data?.nguoiTrinh.thoiGian, "HH:mm dd/MM/yyyy")}
                                        </div>
                                        <div className="name">{data.nguoiTrinh.tenNguoiKy}</div>
                                    </>
                                ) : (
                                    <div className="name">{data?.tenNguoiTrinh || ''}</div>
                                )}
                            </Col>
                        </Row> : <Row gutter={8}>
                            <Col span={12} className="sign-block">
                                <div className="title">{data?.idChanhVP > 0 ? 'CHÁNH VĂN PHÒNG' : data?.idPhoCVP > 0 ? 'PHÓ CHÁNH VĂN PHÒNG' : 'PHỤ TRÁCH VĂN PHÒNG'}</div>
                                {data?.lanhDaoPhong != null ? (
                                    <>
                                        <div className="signed">Đã ký</div>
                                        <div className="time">
                                            {dateCommon.formatDate(data?.lanhDaoPhong.thoiGian, "HH:mm dd/MM/yyyy")}
                                        </div>
                                        <div className="name">{data?.lanhDaoPhong.tenNguoiKy}</div>
                                    </>
                                ) : data?.phoCVP != null ? (
                                    <>
                                        <div className="signed">Đã ký</div>
                                        <div className="time">
                                            {dateCommon.formatDate(data?.phoCVP.thoiGian, "HH:mm dd/MM/yyyy")}
                                        </div>
                                        <div className="name">{data?.phoCVP.tenNguoiKy}</div>
                                    </>
                                ) : (
                                    <div className="name">{data?.tenChanhVP || data?.tenPhoCVP || ''}</div>
                                )}
                            </Col>
                            <Col span={12} className="sign-block">
                                <div className="title">NGƯỜI TRÌNH</div>
                                {data?.nguoiTrinh ? (
                                    <>
                                        <div className="signed">Đã ký</div>
                                        <div className="time">
                                            {dateCommon.formatDate(data?.nguoiTrinh.thoiGian, "HH:mm dd/MM/yyyy")}
                                        </div>
                                        <div className="name">{data.nguoiTrinh.tenNguoiKy}</div>
                                    </>
                                ) : (
                                    <div className="name">{data?.tenNguoiTrinh || ''}</div>
                                )}
                            </Col>
                        </Row>}
                        {
                            data?.idPhoGiamDoc > 0 &&
                            <Row gutter={8} style={{ marginTop: "24px" }}>
                                <Col span={24} className="sign-block">
                                    <div className="title">Ý KIẾN CỦA PHÓ GIÁM ĐỐC PHỤ TRÁCH VĂN PHÒNG</div>
                                    {data?.phoGiamDoc != null ? (
                                        <>
                                            <div className="signed">{data.phoGiamDoc.yKien}</div>
                                            <div className="signed">Đã ký</div>
                                            <div className="time">
                                                {dateCommon.formatDate(data?.phoGiamDoc.thoiGian, "HH:mm dd/MM/yyyy")}
                                            </div>
                                            <div className="name">{data.phoGiamDoc.tenNguoiKy}</div>
                                        </>
                                    ) : (
                                        <div className="name">{data?.tenPhoGiamDoc || ''}</div>
                                    )}
                                </Col>
                            </Row>
                        }
                        <Row gutter={8} style={{ marginTop: "24px" }}>
                            <Col span={24} className="sign-block">
                                <div className="title">PHÊ DUYỆT CỦA PHỤ TRÁCH ĐIỀU HÀNH</div>
                                {data?.lanhDaoQuy != null ? <>
                                    <div className="signed">{data.lanhDaoQuy.yKien}</div>
                                    <div className="signed">Đã ký</div>
                                    <div className="time">
                                        {dateCommon.formatDate(data?.lanhDaoQuy.thoiGian, "HH:mm dd/MM/yyyy")}
                                    </div>
                                    <div className="name">{data.lanhDaoQuy.tenNguoiKy}</div>
                                </> : <>
                                    <div className="name">{data?.tenGiamDoc || ''}</div>
                                </>}
                            </Col>
                        </Row>
                    </div>
            </PrintPage>
            </div>
        </section>
    )
}

export default InDangKyDaoTaoNam;